import React, { Component } from "react";
import {
  Col,
  Row,
  InputGroup,
  Input,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
  UncontrolledDropdown,
} from "reactstrap";
import Responsive from "react-responsive";
import style from "./Toolbar.scss";
import { debounce } from "../../../utils/Helper";
import { KYCStatus, KYCPersonType } from "../types";

const ALL = "All";

const STATUS_OPTIONS = [
  ALL,
  KYCStatus.ComplianceReview,
  KYCStatus.AdvisorReview,
  KYCStatus.Closed,
  KYCStatus.Rejected,
];

const TYPE_OPTIONS = [ALL, KYCPersonType.Physical, KYCPersonType.Juridical];

class Toolbar extends Component {
  state = {
    filters: { ...this.props.filters },
  };

  handleFilterDebounced = debounce(() => {
    this.props.changeFilter({ ...this.state.filters });
  }, 200);

  changeFilterValue = (next) => {
    this.setState(
      (prev) => ({ filters: { ...prev.filters, ...next } }),
      this.handleFilterDebounced
    );
  };

  render() {
    const { filters } = this.state;
    const { counters } = this.props;

    return (
      <div className={style.toolbar}>
        <Counter total={counters.total} filtered={counters.filtered} />

        <Row className={style.filtersRow}>
          <Col xs={12} md={6} lg={4} xl={4}>
            <InputGroup>
              <div className="input-group-prepend">
                <span className="input-group-text">
                  <i className="fa fa-search" />
                </span>
              </div>
              <Input
                type="text"
                placeholder="Search by document number"
                value={filters.documentNumber || ""}
                onChange={(e) => this.changeFilterValue({ documentNumber: e.target.value })}
              />
            </InputGroup>
          </Col>

          <Col xs={6} md={3} lg={2} xl={2} className={style.filterDropdown}>
            <DropDownFilter
              label="Status"
              value={filters.status}
              options={STATUS_OPTIONS}
              onChange={(v) => this.changeFilterValue({ status: v })}
            />
          </Col>

          <Col xs={6} md={3} lg={2} xl={2} className={style.filterDropdown}>
            <DropDownFilter
              label="Type"
              value={filters.type}
              options={TYPE_OPTIONS}
              onChange={(v) => this.changeFilterValue({ type: v })}
            />
          </Col>

          <Col xs={6} md={6} lg={2} xl={2}>
            <InputGroup>
              <div className="input-group-prepend">
                <span className="input-group-text">From</span>
              </div>
              <Input
                type="date"
                value={filters.dateFrom || ""}
                onChange={(e) => this.changeFilterValue({ dateFrom: e.target.value || null })}
              />
            </InputGroup>
          </Col>

          <Col xs={6} md={6} lg={2} xl={2}>
            <InputGroup>
              <div className="input-group-prepend">
                <span className="input-group-text">To</span>
              </div>
              <Input
                type="date"
                value={filters.dateTo || ""}
                onChange={(e) => this.changeFilterValue({ dateTo: e.target.value || null })}
              />
            </InputGroup>
          </Col>
        </Row>
      </div>
    );
  }
}

const Desktop = (props) => <Responsive {...props} minWidth={1000} />;

const Counter = ({ total, filtered }) => (
  <Desktop>
    <div className={style.counterRow}>
      <h6 className={"h6 page-title " + style.totals}>KYC Requests: {total}</h6>
      <span className="text-muted">{filtered} filtered</span>
    </div>
  </Desktop>
);

const DropDownFilter = ({ label, value, options, onChange }) => (
  <UncontrolledDropdown style={{ width: "100%" }}>
    <DropdownToggle caret color="secondary" className={style.dropdown}>
      {value && value !== ALL ? value : label}
    </DropdownToggle>
    <DropdownMenu>
      {options.map((option) => (
        <DropdownItem key={`${label}-${option}`} onClick={() => onChange(option)}>
          {option}
        </DropdownItem>
      ))}
    </DropdownMenu>
  </UncontrolledDropdown>
);

export default Toolbar;
